import { IRequesterInfo } from "@/base/models";
import { ClientProxy } from "@/base/proxy/clientProxy";
import { CreateDemoInstanceRequest, CreateDemoInstanceResponse } from "./models";

export interface AccountNameAvailabilityResponse {
  Available: boolean;
}

/**
 * Canli "Stoneity Hesap Adi" uygunluk kontrolu. Sunucu yalniz Available dondurur;
 * gerekce bilgisi bilerek yoktur (rezerve liste ic bilgidir) ve kullaniciya gosterilen
 * tum metinler sitenin kendi cevirileridir - "subdomain" kelimesi kullanilmaz.
 */
export class AccountNameAPI extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo, name: string) {
    super({
      url: "Website/account-name-availability?name=" + encodeURIComponent(name),
      requesterInfo,
    });
  }

  public async check(): Promise<AccountNameAvailabilityResponse> {
    return await this.getAsync<AccountNameAvailabilityResponse>();
  }
}

export class InstanceAPI extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: "Website/create-instance",
      requesterInfo,
    });
  }

  public async createInstance(data: CreateDemoInstanceRequest): Promise<CreateDemoInstanceResponse> {
    return await this.postAsync<CreateDemoInstanceResponse>(data);
  }
}
